import axios from 'axios';
import { auth } from '../../firebase';

export const updatePlants = async ({
  plantIdList,
  companyId,
  attributes
}) => {
	const apiUrl = `${process.env.REACT_APP_FIREBASE_FUNCTION_HOSTNAME}/updatePlants`;
  const token = await auth.currentUser.getIdToken();
	try {
		const response = await axios.post(
			apiUrl,
			{
        plantIdList,
        companyId,
        attributes
			},
			{
				headers: {
					'Content-type': 'application/json',
          Authorization: `Bearer ${token}`
				},
				validateStatus: status => {
					return status >= 200 && status < 500;
				}
			}
		);
		return response;
	} catch (e) {
		throw e;
	}
};

export default updatePlants;
